import { render, staticRenderFns } from "./training-list-table.vue?vue&type=template&id=36661f7a&"
import script from "./training-list-table.vue?vue&type=script&lang=js&"
export * from "./training-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports